"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fieldType_1 = __importDefault(require("../fieldType"));
const isString_1 = __importDefault(require("lodash/isString"));
const Errors_1 = __importDefault(require("../Errors"));
const includes_1 = __importDefault(require("lodash/includes"));
const isArray_1 = __importDefault(require("lodash/isArray"));
exports.default = (0, fieldType_1.default)({
    name: 'string',
    validate(value, { currentSchema }) {
        if (!(0, isString_1.default)(value))
            return Errors_1.default.NOT_A_STRING;
        if (isFinite(currentSchema.min)) {
            if (value.length < currentSchema.min) {
                return Errors_1.default.STRING_TOO_SHORT;
            }
        }
        if (isFinite(currentSchema.max)) {
            if (value.length > currentSchema.max) {
                return Errors_1.default.STRING_TOO_LONG;
            }
        }
        if ((0, isArray_1.default)(currentSchema.allowedValues)) {
            if (!(0, includes_1.default)(currentSchema.allowedValues, value)) {
                return Errors_1.default.NOT_AN_ALLOWED_VALUE;
            }
        }
        if (value === '' && !currentSchema.optional) {
            return Errors_1.default.REQUIRED;
        }
    },
    clean(value, { options: { autoConvert, trimStrings, removeEmptyStrings } }) {
        if (autoConvert) {
            value = String(value);
        }
        if (trimStrings) {
            value = value.trim();
        }
        if (removeEmptyStrings && value === '') {
            return undefined;
        }
        return value;
    }
});
